import { computed } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

const useCurrentUser = () => {
  // General
  const userId = computed(() => user.value.id)
  const userEmail = computed(() => user.value.email)
  const isSuperUser = computed(() => user.value.is_superuser)

  // CashCall

  const canAccessCashCall = computed(
    () => user.value && user.value.can_access_cash_call === true
  )
  
  const cashCallRole = computed(
    () => user.value && user.value.cash_call_role || null
  )
  
  const canCreateCashCall = computed(
    () => cashCallRole.value === 'TPA'
  )
  

  // FCP
  const { useGetters } = createVuexHelpers()
  const { hasFCPAccess, user } = useGetters(['hasFCPAccess', 'user'])

  // FCP access is driven entirely by the company's fcp_role (Admin/User/View)
  // - company.role.role (Party Type: TPA/Broker/Underwriter/Coverholder) is
  // never consulted here, EXCEPT for Broker: Broker-role companies must always
  // be read-only for FCP regardless of fcp_role, so that check takes priority
  // over fcp_role below. User submits variances, Admin responds to them, and
  // everything else (View, unrecognized, or unset) defaults to read-only.
  const fcpRole = computed(() => {
    if (!hasFCPAccess.value) return null

    if (isSuperUser.value) return 'Superuser'

    if (user.value.company.role && 'Broker' === user.value.company.role.role) {
      return 'ReadOnly'
    }

    if ('User' === user.value.company.fcp_role) return 'User'
    if ('Admin' === user.value.company.fcp_role) return 'Admin'

    return 'ReadOnly'
  })

  // This user's OWN per-member REC status (Members.user_rec_status, via UserDetailSerializer's
  // own get_user_rec_status) - a third gate on top of fcpRole/lead-underwriter for approving a
  // variance (see RecProductionReport.vue's canEditAdminReview). Distinct from fcpRole/
  // hasFCPAccess above, which are both company-wide (every user of an Admin-fcp_role company
  // shares the same fcpRole) - this is the one REC permission that's actually per-user.
  const hasActiveRecStatus = computed(() => 'Active' === user.value.user_rec_status)

  // Environment-level, not per-user: whether this deployment offers the Reconciliation page's Demo
  // Mode toggle at all (backend settings.DEMO_MODE_AVAILABLE - non-production environments only).
  const isDemoModeAvailable = computed(() => true === (user.value && user.value.demo_mode_available))

  return {
    userId,
    userEmail,
    isSuperUser,

    hasFCPAccess,
    fcpRole,
    hasActiveRecStatus,
    isDemoModeAvailable,

    canAccessCashCall,
    cashCallRole,
    canCreateCashCall
  }
}

export default useCurrentUser
